
(function (window, $j, $) {

    var self = {
        apiurl:  '/find/VenueFinder/GetHotelByLocationId?locationId=',
        list: $j('.rfp-hotels-list'),
        emptylist: $j('.empty-hotel-mssg'),
        spinner: $j('.load-spinner'),
        hotels: []
    };

    function onDocReady() {

        $j('.hotel').each(function() {
            self.hotels.push($j(this).attr('data-property-id'));
        });

        $j('#hotel_selector').on('change', function () {
            getHotel($j(this).val());
        });

        $j(document).on('click', '.rem-hotel', function () {
            removeHotel($j(this).attr('data-hotel'));
        });
        
    }

    function getHotel (hotelId) {
        self.spinner.show();
        $j.ajax({
            url: self.apiurl + hotelId,
            type: "GET",
            cache: false,
            success: function (res) {
                result = res;
                addHotel(result);
            },
            error: function (err) {
                self.spinner.hide();
                console.error('Could not retrieve hotel info.');
            }
        });
    }

    function addHotel (res) {
        self.spinner.hide();

        var id = res.meeting_broker_id.toString();

        // Return if hotel is already in the list.
        if (self.hotels.indexOf(id) > -1) {
            return;
        }

        self.hotels.push(id);

        AddToRFP.addtoRFP(id);

        var hotel = hotelTemplate(res);
        self.list.append(hotel);
        if (self.emptylist.length) {
            self.emptylist.remove();
        }
    }

    function removeHotel (hotelId) {
        var hotel = $j('.hotel[data-property-id="' + hotelId +'"]');
        hotel.slideUp(350);

        var hotelindex = self.hotels.indexOf(hotelId, 0);
        if (hotelindex > -1) {
            self.hotels.splice(hotelindex, 1);
        }
        
        AddToRFP.replaceCookie(self.hotels);

        setTimeout(function() {
            hotel.remove();
            if (!self.hotels.length) {
                self.list.append('<span class="empty-hotel-mssg">You currently have no properties selected.</span>');
                self.emptylist = $j('.empty-hotel-mssg');
            }
        }, 350);
    }

    function hotelTemplate (hotel) {
        var image = hotel.ImageSrc ? hotel.ImageSrc : ''; 
        var template =  '\
            <div class="hotel" data-property-id="' + hotel.meeting_broker_id + '" data-hotel-code="' + hotel.PropertyCode +'">\
                <div class="image-container"\
                    style="background-image: url(' + image +');"></div>\
                <div class="details-container">\
                    <a href="' + hotel.HotelUrl +'" class="hotel-name">' + hotel.DisplayName +'</a>\
                    <span class="location">' + hotel.City +', ' + hotel.State +'</span>\
                </div>\
                <div class="delete-container rem-hotel" data-hotel="'+ hotel.meeting_broker_id +'">\
                    <span class="delete-icon"><i class="fa fa-times-circle"></i></span>\
                </div>\
            </div>\
        ';
        return template;
    }

    $j(onDocReady);

    return {};

})(window,$j, jQuery);
